import { ToastContainer, Zoom } from 'react-toastify';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Suspense, useEffect, useState } from 'react';
import Loader from './routes/Loader';
// routes
import browserRoutes from './routes/router';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import { MyProvider } from './pages/provider';
import './css/global.scss';
import 'react-toastify/dist/ReactToastify.css';
import './app.css';
// for developing only, not for production
// for production, we will get data from api
// import translatelang from "./utils/dictionaries/fallbacktranslate";

import { getDictionary } from './utils/dictionaries';
import TawkMessenger from './components/TawkMessenger/tawkMessenger';

export default function App() {
  const [dict, setDict] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchDictionary = async () => {
    const dictionary = await getDictionary();
    setDict(dictionary);
    setLoading(false);
  };
  useEffect(() => {
    fetchDictionary();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <ThemeProvider>
      <HelmetProvider>
        <StyledChart />
        <MyProvider i18={dict}>
          <Suspense>
            <RouterProvider fallbackElement={<Loader />} router={browserRoutes} />
          </Suspense>
          <TawkMessenger />
        </MyProvider>
        <ToastContainer transition={Zoom} theme="colored" limit={3} draggablePercent={60} />
      </HelmetProvider>
    </ThemeProvider>
  );
}

// import { Suspense, useEffect, useState } from 'react';
// import { ToastContainer, Zoom } from 'react-toastify';
// import { RouterProvider } from 'react-router-dom';
// import { HelmetProvider } from 'react-helmet-async';
// import axios from 'axios';
// import Loader from './routes/Loader';
// import browserRoutes from './routes/router';
// import ThemeProvider from './theme';
// import { StyledChart } from './components/chart';
// import { MyProvider } from './pages/provider';
// import './css/global.scss';
// import 'react-toastify/dist/ReactToastify.css';
// import './app.css';
// import { getDictionary } from './utils/dictionaries';
// import TawkMessenger from './components/TawkMessenger/tawkMessenger';

// export default function App() {
//   const [dict, setDict] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [manifestUrl, setManifestUrl] = useState(null);

//   const fetchDictionary = async () => {
//     const dictionary = await getDictionary();
//     setDict(dictionary);
//   };

//   const fetchManifest = async () => {
//     try {
//       const res = await axios.get('https://airstardevapi.abservetechdemo.com/module/settings/pwa');
//       if (res.data.data) {
//         const manifestData = res.data.data;

//         // Ensure start_url is valid (must start with '/')
//         if (!manifestData.start_url || !manifestData.start_url.startsWith('/')) {
//           manifestData.start_url = '/';
//         }

//         // Optional: fallback icons if none provided
//         // if (!manifestData.icons || !Array.isArray(manifestData.icons)) {
//         //   manifestData.icons = [
//         //     {
//         //       src: '/icons/icon-192x192.png',
//         //       sizes: '192x192',
//         //       type: 'image/png',
//         //     },
//         //     {
//         //       src: '/icons/icon-512x512.png',
//         //       sizes: '512x512',
//         //       type: 'image/png',
//         //     },
//         //   ];
//         // }

//         const manifestJson = JSON.stringify(manifestData);
//         const blob = new Blob([manifestJson], { type: 'application/json' });
//         const url = URL.createObjectURL(blob);

//         setManifestUrl(url);
//       }
//     } catch (error) {
//       console.error('Failed to fetch PWA manifest:', error);
//     }
//   };

//   useEffect(() => {
//     const init = async () => {
//       await fetchDictionary();
//       await fetchManifest();
//       setLoading(false);
//     };
//     init();
//   }, []);

//   useEffect(() => {
//     if (!manifestUrl) return;

//     let manifestLink = document.querySelector("link[rel='manifest']");
//     if (!manifestLink) {
//       manifestLink = document.createElement('link');
//       manifestLink.rel = 'manifest';
//       document.head.appendChild(manifestLink);
//     }
//     manifestLink.href = manifestUrl;
//   }, [manifestUrl]);
//   // Revoke the blob URL only once on component unmount (optional cleanup)
//   useEffect(() => () => {
//       if (manifestUrl) {
//         URL.revokeObjectURL(manifestUrl);
//       }
//     }, [manifestUrl]);

//   if (loading) return <Loader />;

//   return (
//     <ThemeProvider>
//       <HelmetProvider>
//         <StyledChart />
//         <MyProvider i18={dict}>
//           <Suspense fallback={<Loader />}>
//             <RouterProvider router={browserRoutes} />
//           </Suspense>
//           <TawkMessenger />
//         </MyProvider>
//         <ToastContainer transition={Zoom} theme="colored" limit={3} draggablePercent={60} />
//       </HelmetProvider>
//     </ThemeProvider>
//   );
// }